// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"418208b6","498":"c4818e6b","703":"b4751eaf","787":"770e3b9d"}[chunkId] + ".chunk.js";
};